import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import tenBoardsUtils from './utils/tenBoards.utils'
import numberUtils from './utils/number.utils'


export default class TenBoardsComponent extends BaseLevel {
    onEnter = () => {
        const answerRequired = this.props.level.settings.answer_required
        let result = 0
        const quantities = this.state.quantities
        if (answerRequired === 'value_1') {
            result = this.state.quantities.value_1
        } else if (answerRequired === 'value_2') {
            result = this.state.quantities.value_2
        } else {
            result = this.state.operation === 'addition' ?
                +this.state.quantities.value_1 + +this.state.quantities.value_2 :
                this.state.quantities.value_1 - this.state.quantities.value_2
        }
        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }

    render() {
        const level = this.props.level
        const stage = this.props.stage
        let settings = level.settings
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const showSum = settings.show_sum
        const commutative = settings.commutative
        const answerString = settings.show_sum ? numberUtils.getNumberString(settings, quantities, answer) : answer
        let mainLayout = null
        if (commutative) {
            let commutativeQuantities = { ...quantities }
            commutativeQuantities.value_1 = quantities.value_2
            commutativeQuantities.value_2 = quantities.value_1
            mainLayout = (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: gameContainerWidth, height: gameContainerHeight }}>
                    {gameContainerHeight > 0 && tenBoardsUtils.getLevelLayout(
                        gameContainerWidth,
                        gameContainerHeight / 2,
                        settings,
                        quantities,
                        answer)}

                    {gameContainerHeight > 0 && tenBoardsUtils.getLevelLayout(
                        gameContainerWidth,
                        gameContainerHeight / 2,
                        settings,
                        commutativeQuantities,
                        answer)}

                </div>
            )
        } else {
            mainLayout = gameContainerHeight > 0 ? tenBoardsUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) : null
        }

        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answerString} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {mainLayout}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/tenBoards.levels.js